import { useMemo } from 'react'
import { useTranslation } from 'react-i18n-lite'

import { AssociatedUsersRelationsProps } from '../Kanban.types'
import { Fields } from '@yes.technology/react-toolkit'

const DEFAULT_IMAGE_PATH =
  'establishment_organization.person_establishment.profile_picture.url'

export default function useAssociatedUsersRelations({
  associatedRelations,
  objectclassFields
}: {
  associatedRelations?: AssociatedUsersRelationsProps
  objectclassFields?: Fields
}) {
  const { t } = useTranslation()

  return useMemo(() => {
    const DEFAULT_ASSOCIATED_USERS_RELATIONS: AssociatedUsersRelationsProps = [
      {
        relation: 'organization_executor',
        readableName: t('task.assigned-executor')
      },
      {
        relation: 'organization_requester',
        readableName: t('task.assigned-requester')
      }
    ]

    const source =
      Array.isArray(associatedRelations) && associatedRelations.length > 0
        ? associatedRelations
        : DEFAULT_ASSOCIATED_USERS_RELATIONS

    return source.reduce((acc: AssociatedUsersRelationsProps, association) => {
      const defaultMatch = DEFAULT_ASSOCIATED_USERS_RELATIONS.find(
        ({ relation }) => relation === association.relation
      )

      let readableName =
        association.readableName ??
        objectclassFields?.[association.relation]?.display_text?.des

      if (defaultMatch) {
        readableName = defaultMatch.readableName
      }

      acc.push({
        ...association,
        image_path: association.image_path || DEFAULT_IMAGE_PATH,
        readableName
      })

      return acc
    }, [])
  }, [associatedRelations, objectclassFields, t])
}
